module.exports = __webpack_public_path__ + "static/img/leisure-phone.4e74d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/meeting-room/leisure-phone.png
// module id = C3Ib
// module chunks = 1